export const colors = {
  navy: '#0a1628',
  navyLight: '#111f35',
  navyCard: '#162340',
  gold: '#d4af37',
  goldDark: '#b8962f',
  cream: '#f5f1e8',
  textSecondary: '#b8c5d6',
  secondary: '#b8c5d6',
  secondaryText: '#b8c5d6',
  textMuted: '#8899aa',
  muted: '#8899aa',
  textDim: '#6b7f99',
  border: '#2d4a6f',
  cranberry: '#8b2942',
};

export const gradients = {
  background: 'linear-gradient(135deg, #0a1628 0%, #111f35 50%, #0a1628 100%)',
  goldButton: 'linear-gradient(135deg, #d4af37 0%, #b8962f 100%)',
  goldShine: 'linear-gradient(135deg, #d4af37 0%, #f5e6a3 50%, #d4af37 100%)',
  goldCranberry: 'linear-gradient(135deg, #d4af37 0%, #8b2942 100%)',
};

export const glass = {
  background: 'rgba(17, 31, 53, 0.6)',
  backgroundDark: 'rgba(17, 31, 53, 0.8)',
  border: '1px solid #2d4a6f',
  card: {
    background: 'rgba(17, 31, 53, 0.6)',
    border: '1px solid #2d4a6f',
    borderRadius: '16px',
    backdropFilter: 'blur(12px)',
  },
};
